import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import ParentForm from 'components/organisms/forms/ParentForm'

import { crudActionsMap } from 'utils/helpers'

const ParentCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  return (
    <>
      <PageHeading title={`${t('common.parents')} / ${t('common.' + action)}`} />
      <PageBody>
        <ParentForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default ParentCrudPage
